<template>
  <div class="usage-funnel-wrapper">
    <div v-if="showExport" class="d-flex justify-end mb-2">
      <ExportButton @click="exportData" tooltip="Export to CSV" />
    </div>

    <v-table density="comfortable">
      <!-- the 4 count columns share the width equally, so each pair sits centred under its group label -->
      <colgroup>
        <col class="col-state" />
        <col class="col-count" />
        <col class="col-count" />
        <col class="col-count" />
        <col class="col-count" />
      </colgroup>
      <thead>
        <!-- [#931] group header: Complete / Pending, each over Usage + Unique User -->
        <tr class="bg-grey-lighten-3">
          <th rowspan="2" class="text-left font-weight-bold">State</th>
          <th colspan="2" class="text-center font-weight-bold group-header">Complete</th>
          <th colspan="2" class="text-center font-weight-bold group-header">Pending</th>
        </tr>
        <tr class="bg-grey-lighten-3">
          <th class="text-center font-weight-bold group-start">Usage</th>
          <th class="text-center font-weight-bold col-divider">Unique User</th>
          <th class="text-center font-weight-bold group-start">Usage</th>
          <th class="text-center font-weight-bold col-divider">Unique User</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in data" :key="index" class="hover-row">
          <td class="font-weight-medium">{{ item.stage }}</td>
          <td class="text-center font-weight-bold group-start">{{ formatCount(item.completeForms) }}</td>
          <td class="text-center text-body-2 col-divider">{{ formatCount(item.completeUniqueUsers) }}</td>
          <td class="text-center text-body-2 group-start">{{ formatCount(item.pendingForms) }}</td>
          <td class="text-center text-body-2 col-divider">{{ formatCount(item.pendingUniqueUsers) }}</td>
        </tr>
      </tbody>
    </v-table>
  </div>
</template>

<script>
import ExportButton from '@/components/TaxDashboard/ExportButton.vue';
import { exportToCSV } from '@/utils/csvExport';

export default {
  name: 'UsageFunnelTable',
  components: {
    ExportButton,
  },
  props: {
    data: {
      type: Array,
      required: true,
    },
    showExport: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    // null/undefined = the state has no pending notion (Created / Completed rows) → "-"; 0 is a real count.
    formatCount(value) {
      if (value === null || value === undefined) return '-';
      return value.toLocaleString('en-US');
    },
    exportData() {
      const headers = [
        { key: 'stage', label: 'State' },
        { key: 'completeForms', label: 'Complete - Usage' },
        { key: 'completeUniqueUsers', label: 'Complete - Unique User' },
        { key: 'pendingForms', label: 'Pending - Usage' },
        { key: 'pendingUniqueUsers', label: 'Pending - Unique User' },
      ];
      const rows = this.data.map((item) => ({
        ...item,
        pendingForms: item.pendingForms ?? '-',
        pendingUniqueUsers: item.pendingUniqueUsers ?? '-',
      }));
      exportToCSV(rows, headers, 'usage_funnel_by_form');
    },
  },
};
</script>

<style scoped>
.usage-funnel-wrapper {
  width: 100%;
}

.hover-row {
  transition: background-color 0.2s ease;
}

.hover-row:hover {
  background-color: rgba(0, 0, 0, 0.02);
}

thead tr th {
  font-size: 0.75rem;
  padding: 12px 8px;
  border-bottom: 2px solid rgba(0, 0, 0, 0.12);
}

tbody tr td {
  padding: 12px 8px;
  font-size: 0.813rem;
}

.col-state {
  width: 28%;
}

.col-count {
  width: 18%;
}

/* divider in front of each Complete / Pending group, and a lighter one between Usage and Unique User */
.group-header,
.group-start {
  border-left: 1px solid rgba(0, 0, 0, 0.12);
}

.col-divider {
  border-left: 1px solid rgba(0, 0, 0, 0.08);
}

thead tr:first-child th.group-header {
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
}
</style>
